// API KEY NEED TO BE UPDATED WHEN BE CHANGES ARE IMPLEMENTED
export const stripeApiKey = process.env.REACT_APP_STRIPE_API_KEY;

export default stripeApiKey;
